import { useContext } from "react";

import { MenuDrawerContext } from "../../contexts/MenuDrawerContext";

export const useMenuDrawerContext = () => {
  const context = useContext(MenuDrawerContext);
  if (context === undefined) {
    throw new Error(
      "useMenuDrawerContext must be within MenuDrawerContextProvider",
    );
  }

  return context;
};
